/** How much of a UUID to show when no human-readable name is available. */
const WORKSPACE_AGENT_SHORT_ID_LENGTH = 8;

/**
 * Shortens an id for display in a session label or an unresolved pill chip, where the full UUID
 * would swamp the surrounding text.
 */
export const truncateWorkspaceAgentId = (id: string): string => id.slice(0, WORKSPACE_AGENT_SHORT_ID_LENGTH);
